import { getAuth } from "firebase/auth";
import { getReadyAuthUser } from "~/utils/auth/waitForAuthReady";
import { LoaderFunctionArgs, redirect } from "react-router-dom";
import { apiClient } from "~/services/apiClient";
import { loadCookiesData } from "~/utils";

export interface MessageContact {
  email: string;
  name: string;
  profilePictureUrl: string;
}

export interface MessagesContactsLoaderResult {
  currentUser: MessageContact;
  contacts: MessageContact[];
}

export const MessagePageLoader = async ({
  request,
}: LoaderFunctionArgs): Promise<MessagesContactsLoaderResult | Response> => {
  const auth = getAuth();
  const user = await getReadyAuthUser();
  if (!user) return redirect("/explore");

  const authAccessInfo = await loadCookiesData(user.uid);
  if (!authAccessInfo.success) return redirect("/explore");

  const result = await apiClient.loader<MessagesContactsLoaderResult>(
    "messages-contacts",
  );

  if (!result.success || !result.data) {
    throw new Error(result.error ?? "Failed to load message contacts");
  }

  return result.data;
};

export type MessagePageLoaderType = MessagesContactsLoaderResult;
